<template>
  <div
    :class="
      classes(
        n('item'),
        [isActive, n('item--active')],
        [props.disabled, n('item--disabled')],
      )
    "
    :data-index="props.index"
    :style="itemStyle"
    @click="handleClick"
  >
    <!-- 图标插槽 -->
    <div
      v-if="showIcon"
      :class="n('item-icon')"
    >
      <slot
        name="icon"
        :active="isActive"
        :disabled="props.disabled"
      >
        <component
          :is="currentIcon"
          v-if="currentIcon"
        />
      </slot>
    </div>

    <!-- 标题插槽 -->
    <div :class="n('item-title')">
      <slot
        name="title"
        :active="isActive"
        :disabled="props.disabled"
      >
        <slot>{{ props.title }}</slot>
      </slot>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'virtual-vue';
import { tabItemProps } from './props';
import { tabItemEmits } from './emits';
import { useTabsInject } from './provide';
import { createNamespace } from '../utils/components';

const { name, n, classes } = createNamespace('tabs');

export default defineComponent({
  name: `${name}-item`,
  props: tabItemProps,
  emits: tabItemEmits,
  setup(props, { emit }) {
    const tabsProvide = useTabsInject();

    const isActive = computed(() => tabsProvide.activeIndex.value === props.index);

    const currentIcon = computed(() => {
      if (!props.icons) {
        return null;
      }
      if (isActive.value) {
        return props.icons.active;
      }
      return props.icons.inactive;
    });

    const showIcon = computed(() => !!(props.icons?.active || props.icons?.inactive));

    const itemStyle = computed(() => {
      const style: Record<string, string> = {};

      // 自定义颜色
      if (isActive.value && tabsProvide.activeColor?.value) {
        style.color = tabsProvide.activeColor.value;
      } else if (!isActive.value && tabsProvide.inactiveColor?.value) {
        style.color = tabsProvide.inactiveColor.value;
      }

      return style;
    });

    const handleClick = (event: MouseEvent) => {
      if (props.disabled) {
        // 触发禁用事件
        const parentEmit = (tabsProvide as any).emit;
        if (parentEmit) {
          parentEmit('disabled', props.index, props.title);
        }
        return;
      }

      emit('click', event);
      tabsProvide.updateActive(props.index, props.title);
    };

    return {
      n,
      classes,
      props,
      isActive,
      currentIcon,
      showIcon,
      itemStyle,
      handleClick,
    };
  },
});
</script>

